import React, { useEffect, useState } from 'react'
import { CIcon } from '@coreui/icons-react'
import {
  CButton, CCol, CRow, CInput, CInputGroup,
  CInputGroupAppend, CInputGroupText
} from '@coreui/react'
import { fs } from '../firebase'
import BookItems from './components/BookItems'
import AddBookModal from './modals/AddBookModal'
import ChapterModal from './modals/ChapterModal'
import General from '../utils/General'

export default function Books() {
  const [books, setBooks] = useState([])
  const [tempBooks, setTempBooks] = useState([])
  const [selectedBook, setSelectedBook] = useState()
  const [showBookModal, setshowBookModal] = useState(false)
  const [showChapterModal, setShowChapterModal] = useState(false)

  const bookRef = fs.collection('books')

  const searchBooks = General.debounce((searchKey) => {
    const results = tempBooks.filter(book => {
      let name = book.name.toString().toLowerCase()
      return name.includes(searchKey.toLowerCase()) || book.number == searchKey
    })
    setBooks(results)
  }, 300)

  useEffect(() => {
    bookRef
      .orderBy('number', 'asc')
      .onSnapshot((querySnapshot) => {
        const items = querySnapshot.docs.map(doc => doc.data())
        setTempBooks(items)
        setBooks(items)
        const size = Buffer.byteLength(JSON.stringify(items))
console.log(size)
        console.log('Snapshot')
      })
  }, [])

  return (
    <>
      <CRow>
        <CCol>
          <h4>Books</h4>
        </CCol>
        <CCol className="text-right">
          <CButton color="dark" className="btn-sm"
            onClick={() => setshowBookModal(!showBookModal)} ><CIcon name="cil-plus" /> Add Book</CButton>
        </CCol>
      </CRow>

      <CRow className="mt-3 mb-3">
        <CCol className="col-12">
          <CInputGroup>
            <CInput
              placeholder="Search by Book name or Number"
              onChange={(e) => searchBooks(e.target.value)}
            />
            <CInputGroupAppend>
              <CInputGroupText className={'bg-dark text-white'}>
                <CIcon name={'cilSearch'} />
              </CInputGroupText>
            </CInputGroupAppend>
          </CInputGroup>
        </CCol>
      </CRow>

      <BookItems
        books={books}
        bookRef={bookRef}
        onAddChapterClick={(book) => {
          setSelectedBook(book)
          setShowChapterModal(true)
        }
        }
        onEditClick={(book) => {
          setSelectedBook(book)
          setshowBookModal(true)
        }
        }
      />

      {
        showBookModal &&
        <AddBookModal
          show={showBookModal}
          book={selectedBook}
          books={books}
          bookRef={bookRef}
          onClose={() => {
            setSelectedBook(null)
            setshowBookModal(false)
          }
          }
        />
      }

      {
        showChapterModal &&
        <ChapterModal
          show={showChapterModal}
          book={selectedBook}
          bookRef={bookRef}
          onClose={() => {
            setSelectedBook(null)
            setShowChapterModal(false)
          }
          }
        />
      }
    </>
  )
}
